import { Routes, Route } from 'react-router-dom';

import { PageLayout } from '@shared/widgets';
import { Survey } from '@widgets/index';
import { RoutePaths } from '@shared/utils';

export const Root = () => {
  return (
    <PageLayout>
      <Routes>
        <Route path={RoutePaths.survey.path} element={<Survey />} />
      </Routes>
    </PageLayout>
  );
};
